// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pop-history {\n  border-radius: 8px 0 0 8px;\n}\n.pop-history .el-drawer__header {\n  margin-bottom: 24px;\n}", ""]);
// Exports
module.exports = exports;
